import { render, staticRenderFns } from "./name_album.html?vue&type=template&id=6b788ff6&scoped=true&external"
import script from "./name_album.vue?vue&type=script&lang=js"
export * from "./name_album.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b788ff6",
  null
  
)

export default component.exports